import React from 'react';
import { Button } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { useMsal, useAccount } from '@azure/msal-react';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { useUpdateWriteoffMutation } from '../../../../services/WriteoffService';
import { clearBackupAction as clearBackup } from '../../../../services/WriteoffService/slice';
import { useNavigate } from 'react-router-dom';

interface SubmitForApprovalButtonProps {
  onError?: (message: string) => void;
}

export const SubmitForApprovalButton: React.FC<SubmitForApprovalButtonProps> = ({ onError }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { currentWriteoff, isEdited } = useAppSelector(state => state.writeoff);
  const [updateWriteoffMutation, { isLoading }] = useUpdateWriteoffMutation();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const isVisible = currentWriteoff?.status?.toUpperCase() === 'DRAFT';

  if (!isVisible) return null;

  const handleSubmitForApproval = async () => {
    if (!currentWriteoff) return;

    const modifiedBy = account?.name || account?.username || 'System';
    const writeoffForApproval = {
      ...currentWriteoff,
      status: 'SUBMITTED',
      modifiedBy
    };

    try {
      await updateWriteoffMutation({ writeoffView: writeoffForApproval }).unwrap();
      dispatch(clearBackup());
      navigate(-1);
    } catch (err) {
      onError?.('Failed to submit for approval. Please try again.');
    }
  };

  return (
    <Button
      variant="contained"
      startIcon={<SendIcon />}
      onClick={handleSubmitForApproval}
      disabled={isLoading || isEdited}
      sx={{
        backgroundColor: '#059669',
        '&:hover': { backgroundColor: '#047857' },
        fontWeight: 600
      }}
    >
      {isLoading ? 'Submitting...' : 'Submit for Approval'}
    </Button>
  );
};

export default SubmitForApprovalButton;
